import { ReactNode, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";
import { userInfoAtom } from "src/atoms";
import { useMyServiceBill } from "src/hooks/api/bill/useMyServiceBill";
import { useGetMyServiceList } from "src/hooks/api/product/useGetMyServiceList";
import { useIsOciProduct } from "src/hooks/recoil/useIsOciProduct";
import { useRouter } from "src/hooks/useRouter";
import { getInicisDataNewCard, saveInicisBill } from "src/service/pay";
import { IGetInicisDataRes } from "src/service/types/pay.type";
import { localStrings } from "src/utils/localization";
import { insertInicisModule } from "src/utils/pay/insertInicisModule";
import { getProductFromSessionStorage } from "src/utils/storage/auth";

export interface IPayDataType {
  buyerEmail: string;
  buyerName: string;
  customerUid: string;
  discountPrice: number;
  mKey: string;
  merchantUid: string;
  mid: string;
  oid: string;
  price: string;
  signature: string;
  timestamp: string;
  couponCode: string;
}
interface IReactInicis {
  payData?: IPayDataType;
  currency: string;
  confirmPolicy?: boolean;
  isPurchase?: boolean;
  goodName: string;
  returnUrl?: string;
  children?: ReactNode;
}

// 카드 교체 후 구독 재개하기 (x)
// 사이트 종료 후 구독 재개하기 (o) 2025-04-29
const ReactInicisCardNew = ({ currency, goodName }: IReactInicis) => {
  // const mobilePurchaseRef = useRef();
  // const [timestamp, setTimestamp] = useState(0);
  // const [oid, setOid] = useState(0);
  // const isTest = window.location.hostname !== "cloudportal.fasoo.com";
  const closeUrl = window.location.href;
  const { lang } = useRouter();
  // const { values, setFieldValue, isValid } = useFormikContext<any>();
  const [payData, setPayData] = useState<IGetInicisDataRes>();
  const { isOciProduct } = useIsOciProduct();
  const { myServiceBill } = useMyServiceBill({});
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const { serviceList } = useGetMyServiceList({});
  // 3. 결제후 returnUrl = [POST] /wapi/cloud/pay/service/returnUrl/restart/{oid}
  const { t } = useTranslation();
  const [returnUrl, setReturnUrl] = useState<string>(
    window.location.origin +
      "/eco-cloud/wapi/cloud/pay/service/returnUrl/restart/" +
      payData?.oid
  );

  // 구매하기 버튼 클릭
  useEffect(() => {
    insertInicisModule();
  }, []);

  const onClickPurchase = async () => {
    // 카드교체이므로 0원으로 결제 진행
    await getInicisDataNewCard({
      serviceBillUid: serviceList[0].serviceBillUid,
    }).then((res) => {
      setPayData(res);
      setReturnUrl(
        window.location.origin +
          "/eco-cloud/wapi/cloud/pay/service/returnUrl/restart/" +
          res?.oid
      );
      saveInicisBill({
        serviceBillUid: serviceList[0].serviceBillUid,
        product: getProductFromSessionStorage(),
        totalPrice: res?.price,
        creditPrice: res?.creditPrice,
        orderID: res?.oid,
      }).then(() => {
        // @ts-expect-error
        const INIStdPay = window?.INIStdPay;

        INIStdPay.pay("inicisForm", {
          success: function (data: any) {
            console.log("Payment successful:", data);
            // 결제 성공 처리
          },
          error: function (data: any) {
            console.error("Payment failed:", data);
            // 결제 실패 처리
          },
          close: function () {
            console.log("Payment window closed");
            // 결제창 종료 처리
          },
        });
      });
    });
  };

  const billPrint_msg = t(
    "siteManagement.paymentHistory.bill.detail.includeVat"
  );

  return (
    <>
      {/* 이니시스 PC 결제 폼 */}
      <form
        className="inicisForm"
        id="inicisForm"
        name="inicisForm"
        method="POST"
        style={{ display: "none" }}
      >
        <input name="version" readOnly value="1.0" />
        <input name="mid" readOnly value={payData?.mid} />
        {/* <input name="goodname" readOnly value="구독 재개하기" /> */}
        <input name="goodname" readOnly value={goodName} />
        <input name="oid" readOnly value={payData?.oid} />
        <input name="price" readOnly value={payData?.price} />
        <input name="currency" readOnly value={currency} />
        <input name="buyername" readOnly value={payData?.buyerName} />
        <input name="buyertel" readOnly value="010-0000-0000" />
        <input name="buyeremail" readOnly value={payData?.buyerEmail} />
        <input name="timestamp" readOnly value={payData?.timestamp} />
        <input name="signature" readOnly value={payData?.signature} />
        <input name="returnUrl" readOnly value={returnUrl} />
        <input name="mKey" readOnly value={payData?.mKey} />
        <input name="gopaymethod" readOnly value="Card" />
        <input name="acceptmethod" readOnly value="below1000:billauth(card)" />
        <input name="billPrint_msg" readOnly value={billPrint_msg} />
        <input name="languageView" readOnly value={lang} />
        <input name="charset" readOnly value="UTF-8" />
        <input name="merchantData" readOnly value="" />
        <input name="tax" readOnly value="0" />
        <input name="taxfree" readOnly value="0" />
        <input type="hidden" readOnly name="closeUrl" value={closeUrl} />
      </form>

      {/* 이니시스 MOBILR 결제 폼 */}
      <b
        className="text text--green cursor-pointer mg ml-10"
        onClick={onClickPurchase}
      >
        {/* 카드교체 후 구독 재개하기 */}
        {t(
          "siteManagement.paymentHistory.paymentManagement.resumeSubscription"
        )}
      </b>
    </>
  );
};

export default ReactInicisCardNew;
